import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="https://www.fresha.com/en-GB/providers/journey-mobile-saunas-bt4tcb6v?allOffer=true&pId=3050221&utm_id=97760_v0_s00_e0_tv4&share=true&menu=true&dppub=true"
                  className="btn btn-custom btn-lg page-scroll"
                  target="_blank"
                  rel="noreferrer"
                >
                  Book Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
